var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFuncaoArredondarMais(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-arredondar-mais",
    transform: "translate(-736 -930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2201",
    "data-name": "Grupo 2201",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2200",
    "data-name": "Grupo 2200",
    transform: "translate(530.037 668.451)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1208",
    "data-name": "Caminho 1208",
    d: "M214.615,279.993H219.4l-3.863,13.264h-3.575Z",
    transform: "translate(0 11.063)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1209",
    "data-name": "Caminho 1209",
    d: "M229.693,284.714h-10.9v-3.921h10.9V269.549h4.036v11.244h11.013v3.921H233.729v11.361h-4.036Z",
    transform: "translate(7.237 0)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_446",
    "data-name": "Ret\\xE2ngulo 446",
    width: 50,
    height: 50,
    transform: "translate(736 930)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoArredondarMais);
export default __webpack_public_path__ + "static/media/ico-funcao-arredondar-mais.c789e79d239db3008268e2ca9f025994.svg";
export { ForwardRef as ReactComponent };